import React from 'react';
const rows = [['Rebuilding the class every week', 'The right session in under a minute'], ['One plan that fits nobody in the room', 'Ground, Lift and Fly in the same session'], ['Explaining spots and exits from memory', 'Spotter position and way down written in'], ['Seven people and no spotter', 'Odd-number fixes and Rescue Cards'], ['Jams that drift', 'Rotation, theme and skill-share jams, minute by minute']];
export function CostOfInaction() {
  return <section className="w-full bg-night-deep" data-id="element-98" data-mp="38xllnpvh9x7c">
      <div className="mx-auto max-w-3xl px-5 py-14 sm:py-20" data-id="element-99" data-mp="38wains9uwtha">
        <h2 className="text-center font-display text-[28px] leading-tight text-sand sm:text-4xl" data-id="element-100" data-mp="3dolgmpl1e577">
          What another year of improvising costs you
        </h2>
        <div className="mt-8 overflow-hidden rounded-3xl border border-sand/15" data-id="element-101" data-mp="3ipiz739yl198">
          <div className="grid grid-cols-2 text-center" data-id="element-102" data-mp="3no2ondnrgv6c">
            <div className="border-r border-sand/15 bg-signal px-3 py-3 font-display text-base text-white sm:text-lg" data-id="element-103" data-mp="3sl2vhqsfq1yi">
              Improvising
            </div>
            <div className="bg-lift px-3 py-3 font-display text-base text-night sm:text-lg" data-id="element-104" data-mp="3eeddh5jvn1ge">
              Acro Yoga Class Ready
            </div>
          </div>
          {rows.map(([bad, good]) => <div key={bad} className="grid grid-cols-2 border-t border-sand/15 text-[13px] leading-snug sm:text-sm" data-id="element-105" data-mp="34k3idg3jvp1z">
              <div className="border-r border-sand/15 px-3.5 py-3.5 text-sand/60 line-through decoration-signal/60" data-id="element-106" data-mp="108l6afox5eh">
                {bad}
              </div>
              <div className="px-3.5 py-3.5 font-bold text-sand" data-id="element-107" data-mp="3ngwbnccpwpwb">{good}</div>
            </div>)}
        </div>
      </div>
    </section>;
}